export const downloadFile = (stringData: string, fileName: string): void => {
    const linkSource = stringData;
    const downloadLink = document.createElement('a');
    const file = fileName;

    downloadLink.href = linkSource;
    downloadLink.download = file;
    downloadLink.click();
};